
import React from 'react';
import { motion } from 'framer-motion';
import { PHASES } from '../constants';

const Curriculum: React.FC = () => {
  return (
    <section id="curriculum" className="py-24 px-6 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <p className="text-[#FFC222] font-bold mb-4 uppercase tracking-widest">Curriculum</p>
            <h2 className="text-4xl md:text-6xl font-black">1년의 실전 압축 성장</h2>
          </div>
          <div className="text-zinc-500 font-medium">Timeline 2026-여름방학</div>
        </div>

        <div className="relative">
          {/* Vertical Line for Mobile */}
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-zinc-800 md:hidden"></div>
          
          <div className="grid md:grid-cols-4 gap-8">
            {PHASES.map((phase, idx) => (
              <motion.div
                key={phase.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.2 }}
                className="relative pl-12 md:pl-0"
              >
                {/* Connector Node */}
                <div className="absolute left-2.5 md:left-0 md:-top-4 w-4 h-4 rounded-full bg-[#FFC222] ring-8 ring-black ring-opacity-100 z-10"></div>
                
                <div className="bg-zinc-900 p-8 rounded-3xl h-full border border-zinc-800 hover:border-[#FFC222]/50 transition-colors group">
                  <div className="text-zinc-500 font-bold mb-4">{phase.title}</div>
                  <h3 className="text-xl font-bold mb-6 text-white group-hover:text-[#FFC222] transition-colors">{phase.subtitle}</h3>
                  <p className="text-zinc-400 text-sm leading-relaxed">
                    {phase.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Curriculum;
